/**
 * @file index.tsx
 *
 * @fileoverview Renders the contact request confirmation alert.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '~/vcl/atoms/18-alert';

interface ContactRequestConfirmationProps {
  /**
   * Determines if the alert is open.
   */
  openConfirmDialog: boolean;
  /**
   * The user's resume credits.
   */
  userResumeCredits: number;
  /**
   * Function to handle the confirmation of the contact request.
   */
  onConfirm: () => void;
  /**
   * Function to handle the cancellation of the contact request.
   */
  onClose: () => void;
}
export default function ContactRequestConfirmation({
  openConfirmDialog,
  userResumeCredits,
  onConfirm,
  onClose,
}: ContactRequestConfirmationProps) {
  return (
    <Alert
      isShown={openConfirmDialog}
      onConfirm={onConfirm}
      onClose={onClose}
      confirmText={
        <FormattedMessage
          id="confirm_contact_request_no_approval"
          defaultMessage="Confirm"
        />
      }
      cancelText={<FormattedMessage id="cancel" defaultMessage="Cancel" />}
      alertLabel={
        <FormattedMessage
          id="confirm_contact_request_no_approval_label"
          defaultMessage="Request access"
        />
      }
    >
      <FormattedMessage
        id="confirm_contact_request_no_approval_text"
        defaultMessage="Are you sure you want to request access to this resume? You have {credits} credits"
        values={{
          credits: userResumeCredits,
        }}
      />
    </Alert>
  );
}
